import $ from 'jquery';
import slick from 'slick-slider'
import slider from './slider';

$(function () {
    
  slider($)

        const mobileRegex = /^[6-9]\d{9}$/;

        // Flip Cards
        $(`.who--choose-cards-list .list--card-btn`).on('click', function () {

          if ($(this).parents(`.who--choose-cards-list`).hasClass('active')) {
            $(this).parents(`.who--choose-cards-list`).removeClass('active')
          } else {
            $(`.who--choose-cards-list`).removeClass('active')
            $(this).parents(`.who--choose-cards-list`).addClass('active')
          }
        })

        // Scroll To
        $(`[data-scrollto]`).on('click', function (e) {
          const element = document.getElementById($(this).data("scrollto"));
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - 200;
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        })
        
        // Generate Icons 
        $("[data-path]").each(function () {
          let totPaths = parseInt($(this).attr("data-path"), 10),
            i = 0;
          for (let i = 1; i < totPaths + 1; i++) {
            $(this).append('<span class="path' + i + '"></span>');
          }
        });

        $(`input[type="tel"]`).on("input", function (e) {
          this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
        })
      
        $('input[type="text"]:not(.special)').on("input", function (e) {
          this.value = this.value.replace(/[^a-zA-Z ]/g, '');
        })
      
        $(".inClinic").on("submit", async function(e) {
          e.preventDefault();

          const formID = $(this).attr('id')
          
          let isValid = true;
      
          const fullName = $(this).find(`#${formID}--fullName`)
          const phoneNumber = $(this).find(`#${formID}--phoneNumber`)
          const tncCheck = $(this).find(`#${formID}--tnc`)
          const coupon = $(this).find(`#${formID}--couponCode`)
          const appointmentType = $(this).data("value")
      
          const fullNameValue = fullName.val()
          const phoneNumberValue = phoneNumber.val()
          const couponValue = coupon.val()
          const tncCheckValue = tncCheck.is(":checked")
      
          if(isEmpty(fullNameValue) || fullNameValue.startsWith(' ')) {
            fullName.parents(".form-group").find(".message").text("Please enter your full name");
            isValid = false
          } else {
            fullName.parents(".form-group").find(".message").text("");
          }
          
          if(isEmpty(phoneNumberValue) || !mobileRegex.test(phoneNumberValue)) {
            phoneNumber.parents(".form-group").find(".message").text("Please enter a valid phone number");
            isValid = false
          } else {
            phoneNumber.parents(".form-group").find(".message").text("");
          }
          
          if(!tncCheckValue) {
            tncCheck.parents(".check--radio").find(".message").text("This field is mandatory");
            isValid = false
          } else {
            tncCheck.parents(".check--radio").find(".message").text("");
          }
          
          if(isValid) {

            $(this).find(`button[type="submit"]`).prop("disabled", true)

            const params = new URLSearchParams(window.location.search);
            const queryString = params.toString();
            
            const url = `${process.env.API_BASE_URL}book-appointment?full_name=${fullNameValue}&mobile_number=${phoneNumberValue}&coupon_code=${couponValue}&appointment_type=${appointmentType || ""}&${queryString}`

            const response = await fetch(url, {method: "POST"})
            const res = await response.json()

            if(res.success) {
              fullName.val("")
              phoneNumber.val("")
              coupon.val("")
              $(this).removeData('value')
              tncCheck.prop('checked', false);
              $('.inClinic').trigger('reset')
              window.location.href = './thankyou.html'

              $(this).find(`.submit--message`).removeClass('.color--error').addClass(`color--success`).text(res.message || "")
            } else {
              $(this).find(`.submit--message`).removeClass('.color--success').addClass(`color--error`).text(res.message || "")
            }
            
            setTimeout(() => {
              $(this).find(`.submit--message`).text("")
            }, 3000)
      
            $(this).find(`button[type="submit"]`).prop("disabled", false)
          }
          
        })

        //modal start here
      $("[data-modal-open]").on("click", function () {
        let modalId = $(this).data("modal-open");
        $("#appointmentForm").attr('data-value', $(this).data('value'))
        openModal(modalId);
      });

      $(".modal--close, .overlay").on("click", function () {
        $(".modal, .overlay").removeClass("show");
        $(".inClinic").trigger("reset");
        $('.message').html('')
        
        $("body").removeClass("block");

        $("#appointmentForm").attr('data-value', "")
      });
      //modal end here

      $(".overlay").on("click", function () {
        $("#lightbox").removeClass("show");
  });
        
  $(window).scroll(function() {
    if ($(window).scrollTop() > 700) {
        $('.scrollToTop').fadeIn();
    }
    else {
        $('.scrollToTop').fadeOut();
    }
  });
  
  $('.scrollToTop').click(function(event) {
    event.preventDefault();
    $('html, body').animate({scrollTop: 0}, 100);
  });

  var isiDevice = / iPod| iPad| iPhone/i.test(navigator.userAgent.toLowerCase());
    if (isiDevice) {
        document.addEventListener('touchmove', function (event) {
            if (event.scale !== 1) {
                event.preventDefault();
            }
        }, {
            passive: false
        });
    }
     
});
function openModal(modalId) {
  $("body").addClass("block");
  $('[data-modal-id="' + modalId + '"], .overlay').addClass("show");
}
export function isEmpty(val) {
    return val === undefined || val == null || val == "NaN" || val == "undefined" || val.length === 0 || Object.keys(val).length === 0 || val == '' ? true : false;
  }